import { collection, doc, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase/firebase";
import {
  ADMIN,
  CONFIGURABLES,
  PERMISSIONS,
  ROLES,
  sCategories,
  sFeed,
  sNotifications,
  sOrders,
  SORT,
  sProducts,
  sRegions,
  sShops,
  sUsers,
} from "./strings";
import { CONFIG, PAYMENTS, TEMPLATES, TICKETS } from "./webapp";

// BASE COLLECTIONS
export const SHOPS_API = collection(db, sShops);
export const CATEGORIES_API = collection(db, sCategories);
export const PRODUCTS_API = collection(db, sProducts);
export const USERS_API = collection(db, sUsers);
export const ORDERS_API = collection(db, sOrders);
export const FEED_API = collection(db, sFeed);
export const REGIONS_API = collection(db, sRegions);
export const REPORTS_STATS_API = doc(db, "reports", "stats");
export const NOTIFICATIONS_API = collection(db, sNotifications);
export const TICKETS_API = collection(db, TICKETS.toLocaleLowerCase());
export const PAYMENTS_API = collection(db, PAYMENTS);
export const TEMPLATES_API = collection(db, TEMPLATES);
export const ROLES_API = collection(db, ADMIN, CONFIGURABLES, ROLES);
export const PERMISSIONS_API = collection(
  db,
  ADMIN,
  CONFIGURABLES,
  PERMISSIONS
);

// REFS
export const PAYMENT_METHODS_REF = `${CONFIG}/payment_methods`;
export const CONTACTS_REF = `${CONFIG}/contacts`;
export const VERSION_REF = `${CONFIG}/version`;

// QUERIES
// all child categories
export const categoriesQuery = query(
  CATEGORIES_API,
  where("parent", "!=", "top-menu")
);

// to get sub categories
export const subCategoryQuery = (parentId) =>
  query(CATEGORIES_API, where("parent", "==", parentId));

// all parent categories
export const topCategoryQuery = query(
  CATEGORIES_API,
  orderBy(SORT),
  where("parent", "==", "top-menu")
);
